import type { UsersListParams } from "@common/api/users"
import { z } from "zod"

export const userFilterSchema = z.object({
  search: z.string().optional().catch(undefined),
  roles: z.array(z.string()).optional().catch(undefined),
  active: z.boolean().optional().catch(undefined),
})

export type UserFilterValues = z.infer<typeof userFilterSchema>

export function toUsersListParams(search: UserFilterValues): UsersListParams {
  return {
    search: search.search?.trim() || null,
    role_ids: search.roles?.length ? search.roles : null,
    is_active: search.active ?? null,
    sort_by: "name",
    sort_direction: "asc",
  }
}
